"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEagerComponentLoaders = exports.createLazyComponentLoaders = exports.createComponentLoader = exports.getComponentAssets = void 0;
const utils_1 = require("../utils");
const createException_1 = require("../createException");
function getComponentAssets({ resource, parts = {}, }) {
    const assets = [];
    const applyAssets = (_resource) => {
        var _a;
        if (_resource === null || _resource === void 0 ? void 0 : _resource.src) {
            if (_resource.id && _resource.src.js) {
                assets.push({
                    id: _resource.id,
                    url: _resource.src.js,
                    type: 'model',
                });
            }
            if (_resource.src.css) {
                assets.push({
                    url: _resource.src.css,
                    type: 'style',
                });
            }
            (_a = _resource.src.deps) === null || _a === void 0 ? void 0 : _a.forEach(dep => {
                assets.push({
                    url: dep,
                    dependency: true,
                    type: (0, utils_1.isJS)(dep) ? 'model' : 'style',
                });
            });
        }
    };
    applyAssets(resource);
    Object.keys(parts).forEach(partName => {
        applyAssets(parts[partName]);
    });
    return assets;
}
exports.getComponentAssets = getComponentAssets;
function createComponentLoader({ resource, parts = {}, loadBundle, statics, }) {
    const loader = async (part) => {
        /**
         * TODO:
         * - filter model & part deps
         */
        if (resource.src.deps) {
            await Promise.all([
                ...resource.src.deps.filter(utils_1.isJS).map(dep => loadBundle({
                    url: dep,
                })),
                loadBundle({
                    assets: resource.src.deps.filter(utils_1.isCSS),
                }),
            ]);
        }
        const tasks = [];
        if (part) {
            const componentPart = parts[part];
            tasks.push(loadBundle({
                id: componentPart.id,
                url: componentPart.src.js,
                assets: [componentPart.src.css],
            }));
        }
        else if (resource.id) {
            tasks.push(loadBundle({
                id: resource.id,
                url: resource.src.js,
                assets: [resource.src.css],
            }));
            const batchRequests = Object.keys(parts)
                /**
                 * get eager parts
                 */
                .filter(partName => parts[partName].batched);
            batchRequests.forEach(partName => {
                const batchedPart = parts[partName];
                tasks.push(loadBundle({
                    id: batchedPart.id,
                    url: batchedPart.src.js,
                    assets: [batchedPart.src.css],
                }));
            });
        }
        const bundles = await Promise.all(tasks);
        if (bundles.some(bundle => !bundle || !bundle.components)) {
            throw (0, createException_1.createException)(createException_1.RegistryErrorCode.NoComponentsAtComponentBundle);
        }
        const model = Object.assign({}, ...bundles.map((bundle) => bundle ? bundle.components[resource.name] : {}));
        return part ? model[part] : model;
    };
    loader.isPartExist = part => part in parts;
    loader.statics = statics;
    loader.assets = getComponentAssets({ resource, parts });
    return loader;
}
exports.createComponentLoader = createComponentLoader;
function createLazyComponentLoaders({ manifest, loadBundle, }) {
    const components = manifest.getComponents();
    const parts = manifest.getParts();
    const loaders = {};
    Object.keys(components).forEach(componentName => {
        loaders[componentName] = createComponentLoader({
            resource: components[componentName],
            parts: parts[componentName],
            loadBundle,
            statics: manifest.getStatics(componentName),
        });
    });
    return loaders;
}
exports.createLazyComponentLoaders = createLazyComponentLoaders;
async function createEagerComponentLoaders({ manifest, loadBundle, }) {
    const components = manifest.getComponents();
    const parts = manifest.getParts();
    const resource = manifest.getHostBundleModel();
    if (!resource.src.js || !resource.id) {
        return {};
    }
    const bundle = await loadBundle({
        id: resource.id,
        url: resource.src.js,
        assets: [resource.src.css],
    });
    if (!bundle || !bundle.components) {
        throw (0, createException_1.createException)(createException_1.RegistryErrorCode.NoComponentsAtHostBundle);
    }
    const loaders = {};
    Object.keys(bundle.components).forEach(componentName => {
        const loader = (() => Promise.resolve(bundle.components[componentName]));
        loader.assets = getComponentAssets({
            resource: components[componentName],
            parts: parts[componentName],
        });
        loader.statics = manifest.getStatics(componentName);
        loader.isPartExist = () => true;
        loaders[componentName] = loader;
    });
    return loaders;
}
exports.createEagerComponentLoaders = createEagerComponentLoaders;
//# sourceMappingURL=createComponentLoaders.js.map